import apiClient from "./api";
const SUCURSAL_API_BASE_URL = "/sucursales";
class SucursalService {
  getSucursales() {
    return apiClient.get(SUCURSAL_API_BASE_URL);
  }
  agregarSucursal(sucursal) {
    return apiClient.post(SUCURSAL_API_BASE_URL, sucursal);
  }
  updateSucursal(sucursal) {
    return apiClient.put(SUCURSAL_API_BASE_URL, sucursal);
  }
  deleteSucursal(sucursalId) {
    return apiClient.delete(SUCURSAL_API_BASE_URL + "/" + sucursalId);
  }
  async buscarSucursales(busqueda) {
    try {
      const response = await apiClient.post(`${SUCURSAL_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getSucursalIndividual(sucursalId) {
    try {
      const response = await apiClient.get(`${SUCURSAL_API_BASE_URL}/${sucursalId}`);
      return response.data.sucursal[0];
    } catch (error) {
      console.error(error);
    }
  }

  async validarSucursal(nombre, abreviatura) {
    try {
      const response = await apiClient.post(`${SUCURSAL_API_BASE_URL}/validar`, { nombre, abreviatura });
      const sucursal = response.data;
      return sucursal;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new SucursalService();